import React from "react";
//Limitless imports
import { useKnowledgeLibraryContext } from "../../hooks/knowledge/KnowledgeLibraryContext";
import Grid from "@limitless/modern/layout/Grid";
import Typography from "@limitless/modern/data-display/typography/Typography";
const NoArticle = () => {
  const {
    libraryResults,
    selectCategory
  } = useKnowledgeLibraryContext();
  const {
    searchTerm
  } = libraryResults;
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    mt: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    sx: {
      color: theme => theme.palette.text.secondary
    },
    translationSubstitutes: searchTerm
  }, "No articles found for '{0}'."), /*#__PURE__*/React.createElement(Typography, {
    onClick: () => selectCategory(null),
    variant: "body2",
    sx: {
      color: theme => theme.palette.primary.main,
      paddingLeft: "5px",
      cursor: "pointer"
    }
  }, "View FAQs"));
};
export default NoArticle;